module.exports = __webpack_public_path__ + "static/media/arrow.f67e2c31.svg";